import { render, staticRenderFns, recyclableRender, components } from "./uploadOne.vue?vue&type=template&id=3ef8c05c&"
var renderjs
import script from "./uploadOne.vue?vue&type=script&lang=js&"
export * from "./uploadOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/upload/uploadOne.vue"
export default component.exports